import {Box, Button, Stack, Dialog, DialogTitle, DialogContent, IconButton, Alert} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import {useState, useRef} from "react";
import TenantUserRolesGrid from "../components/Tenants/TenantUserRolesGrid";
import Window from "../components/Window/Window";
import TicketInvitationForm from "../components/Tickets/TicketsInvitationForm";

const UsuariosPanel = () => {
  const productId = process.env.REACT_APP_PANEL_PRODUCT_ID_IDENTITY;
  const tenantId = process.env.REACT_APP_PANEL_TENANT_ID_TS_SUPPORT;

  const [isCreatingInvitation, setIsCreatingInvitation] = useState(false);
  const gridRef = useRef();

  const missingEnvVars = [
    !productId && "REACT_APP_PANEL_PRODUCT_ID_IDENTITY",
    !tenantId && "REACT_APP_PANEL_TENANT_ID_TS_SUPPORT"
  ].filter(Boolean);

  if (missingEnvVars.length > 0) {
    return (
      <Alert severity="error">
        Faltan variables de entorno necesarias para utilizar este componente: {missingEnvVars.join(", ")}
      </Alert>
    );
  }

  const handleOpenInvitation = async () => {
    if (gridRef.current && typeof gridRef.current.reloadUsuarios === "function") {
      await gridRef.current.reloadUsuarios();
    }
    setIsCreatingInvitation(true);
  };

  /*  const handleFilteredSearch = (data) => {
    return data.filter((r) => r.tenant_id === tenantId && r.product_id === productId);
  }; */

  return (
    <Window title="Usuarios Panel">
      <Box sx={{mt: 2}}>
        <Stack direction="row" spacing={2} mb={2}>
          <Button
            variant="contained"
            color={isCreatingInvitation ? "error" : "success"}
            onClick={isCreatingInvitation ? () => setIsCreatingInvitation(false) : handleOpenInvitation}
          >
            {isCreatingInvitation ? "Cancelar" : "Generar invitación"}
          </Button>
        </Stack>

        <Dialog open={isCreatingInvitation} onClose={() => setIsCreatingInvitation(false)} maxWidth="xs" fullWidth>
          <DialogTitle sx={{m: 0, p: 2}}>
            Generar invitación
            <IconButton
              aria-label="close"
              onClick={() => setIsCreatingInvitation(false)}
              sx={{
                position: "absolute",
                right: 8,
                top: 8,
                color: (theme) => theme.palette.grey[500]
              }}
            >
              <CloseIcon />
            </IconButton>
          </DialogTitle>
          <DialogContent dividers>
            <Box mb={2}>
              <Box
                sx={{
                  backgroundColor: "#fff3cd",
                  color: "#856404",
                  border: "1px solid #ffeeba",
                  borderRadius: 1,
                  p: 2,
                  mb: 2,
                  fontSize: 15,
                  display: "flex",
                  alignItems: "center"
                }}
              >
                Vas a crear un nuevo usuario que podrá gestionar el acceso y control de este panel.
              </Box>
            </Box>
            <TicketInvitationForm
              onSuccess={() => setIsCreatingInvitation(false)}
              onCancel={() => setIsCreatingInvitation(false)}
            />
          </DialogContent>
        </Dialog>

        <TenantUserRolesGrid
          ref={gridRef}
          productId={productId}
          tenantId={tenantId}
          /* filterData={handleFilteredSearch} */
        />
      </Box>
    </Window>
  );
};

export default UsuariosPanel;
